<mat-form-field class="w-100">
  <mat-label>File</mat-label>
  <mat-icon matPrefix>file_upload</mat-icon>
  <input
    matInput
    [readonly]="true"
    [value]="fileName"
    (click)="fileInput.click()"
    [required]="required"/>
</mat-form-field>
<input
  #fileInput
  type="file"
  id="inputFile"
  (change)="valueChanged($event)"
  [accept]="_accept"
  [disabled]=_disabled
  hidden>